//최근 분실물 미리보기 영역
import React, { useState, useEffect } from "react";
import LostItemCard from "./LostItemCard";
import { useNavigate } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient";
import "./LostItemPreviewSection.css";


function formatDate(dateStr) {
  if (!dateStr) return "";
  const d = new Date(dateStr);
  const yy = String(d.getFullYear()).slice(2);
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yy}.${mm}.${dd}`;
}

function LostItemPreviewSection() {
  const [lostItems, setLostItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  // 컴포넌트 마운트 시 최근 분실물 4건을 Supabase에서 조회
  useEffect(() => {
    const fetchLostItems = async () => {
      const { data, error } = await supabase
        .from("lost_items")
        .select("id, title, item_type, location, item_date")
        .order("created_at", { ascending: false })  // 최신 등록순 정렬
        .limit(4);  // 메인화면 미리보기이므로 4건만 표시

      if (!error && data) {
        // DB 컬럼명(title, item_type)을 컴포넌트 prop 이름(name, status)에 맞게 변환
        setLostItems(
          data.map((item) => ({
            id: item.id,
            name: item.title,
            status: item.item_type,
            location: item.location,
            date: formatDate(item.item_date),
          }))
        );

      }
      setIsLoading(false);
    };

    fetchLostItems();
  }, []);

  return (
    <section className="lost-preview-container">
      <div className="section-header">
        <h3 className="section-title">최근 분실물</h3>
        <span className="more-button" onClick={() => navigate('/lost')}>더보기</span>
      </div>

      <div className="cards-wrapper">
        {isLoading ? (
          <p>분실물 목록을 불러오는 중입니다...</p>
        ) : lostItems.length === 0 ? (
          <p>등록된 분실물이 없습니다.</p>
        ) : (
          lostItems.map((item) => (
            <LostItemCard
              key={item.id}
              name={item.name}
              status={item.status}
              location={item.location}
              date={item.date}
              onClick={() => navigate("/lost", { state: { openItemId: item.id } })}
            />
          ))
        )}
      </div>
    </section>
  );
}

export default LostItemPreviewSection;
